import { useGetAllBadgeFleet } from "../../../api/badge";
import { CustomLoader } from "../../../components/CustomLoader/CustomLoader";
import { CustomTable } from "../../../components/CustomTable/CustomTable";
import { getCurrentFleetId } from "../../../utils/getCurrentFleet";
import { useTranslation } from "react-i18next";
import { getColumnsBadges } from "./columnsBadges";
import { useServerPagination } from "../../../hooks/useServerPagination";
import { useMemo } from "react";

export const Badges = () => {
  const { t } = useTranslation();
  const pagination = useServerPagination();

  // Keye sur `t` : les en-tetes se reconstruisent au changement de langue.
  const columns = useMemo(() => getColumnsBadges(t), [t]);

  const {
    badges,
    isPending: isPendingBadges,
    totalCount,
  } = useGetAllBadgeFleet(
    getCurrentFleetId(),
    pagination.page,
    pagination.perPage,
    pagination.search
  );

  return (
    <>
      {isPendingBadges && <CustomLoader isActive={isPendingBadges} />}

      <CustomTable
        columns={columns}
        data={badges}
        titleHeader={t("collaborator.badges", "Badges")}
        tableMaxHeight={"300px"}
        isSearchable
        isFilterFromBackend
        tablePagnationCount={totalCount}
        {...pagination.tableProps}
        // showSelectedField
        // componentHeader={
        //   <>
        //     <CustomButtonTable
        //       variant={"primary"}
        //       textVariant={"link"}
        //       label={t("common.groupeActions", "Groupe actions")}
        //       width={"fit-content"}
        //       fontWeight={"bold"}
        //       textDecoration={"none"}
        //       iconName={"chevronDown"}
        //       padding={"0px 15px"}
        //       textTransform="uppercase"
        //       endIcon
        //     />
        //   </>
        // }
      />
    </>
  );
};

export default Badges;
